import React from "react";
import MapIcon from "@mui/icons-material/Map";
import DirectionsBoatIcon from "@mui/icons-material/DirectionsBoat";
import ArchitectureIcon from "@mui/icons-material/Architecture";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import GetAppIcon from "@mui/icons-material/GetApp";
import AssessmentIcon from "@mui/icons-material/Assessment";
import SyncAltIcon from "@mui/icons-material/SyncAlt";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import HomeWorkOutlinedIcon from "@mui/icons-material/HomeWorkOutlined";
import InventoryOutlinedIcon from "@mui/icons-material/InventoryOutlined";
import RequestQuoteIcon from "@mui/icons-material/RequestQuote";
import StorefrontIcon from "@mui/icons-material/Storefront";
import PaletteIcon from "@mui/icons-material/Palette";
import CategoryIcon from "@mui/icons-material/Category";
import LabelIcon from "@mui/icons-material/Label";
import FarmReports from "./pages/FarmReports";
import TransfersandFarmTotals from "./pages/TransfersandFarmTotals";

// OysterMate
const Map = React.lazy(() => import("@portal/pages/OysterPL8/Map"));
const OnShore = React.lazy(() => import("@portal/pages/OysterPL8/OnShore"));
const LineDesigner = React.lazy(() => import("@portal/pages/OysterPL8/LineDesigner"));
const History = React.lazy(() => import("@portal/pages/OysterPL8/History"));
const DataDownload = React.lazy(() => import("@portal/pages/OysterPL8/DataDownloads"));
const TotalsReport = React.lazy(() => import("@portal/pages/Farms/TotalsReport"));
const Movements = React.lazy(() => import("@portal/pages/OysterPL8/OMLogs/Movements"));
const Deployments = React.lazy(() => import("@portal/pages/OysterPL8/OMLogs/Deployments"));
const FlipHistory = React.lazy(() => import("@portal/pages/OysterPL8/OMLogs/FlipHistory"));
const LeaseBreakDown = React.lazy(() => import("@portal/pages/OysterPL8/OMLogs/LeaseBreakDown"));
const OCloudCustomers = React.lazy(() => import("./pages/Admin/OCloudCustomers"));
const OCloudSuppliers = React.lazy(() => import("./pages/Admin/OCloudSuppliers"));
const OCloudCropColours = React.lazy(() => import("./pages/Admin/OCloudCropColours"));
const OCloudGrades = React.lazy(() => import("./pages/Admin/OCloudGrades"));
const OCloudUnitTypes = React.lazy(() => import("./pages/Admin/OCloudUnitTypes"));

// Farms
const Agenda = React.lazy(() => import("@portal/pages/Farms/Agenda"));
const MonthlyFarmReport = React.lazy(() => import("@portal/pages/Farms/MonthlyFarmReport"));
const FarmOTRs = React.lazy(() => import("@portal/pages/Farms/FarmOTRs"));
const EquipmentRegistryPage = React.lazy(() => import("@portal/pages/Farms/EquipmentRegistry"));

const mapRoute = { path: "/", label: "Map", element: <Map />, icon: <MapIcon sx={{ fontSize: 20 }} /> };

export const routeSections = [
  {
    title: "Oyster Mate",
    items: [
      mapRoute,
      { path: "/OysterM8/OnShore", label: "On Shore", element: <OnShore />, icon: <DirectionsBoatIcon sx={{ fontSize: 20 }} /> },
      { path: "/OysterM8/LineDesigner", label: "OM8 Builder", element: <LineDesigner />, icon: <ArchitectureIcon sx={{ fontSize: 20 }} /> },
      // { path: "/OysterM8/History", label: "History", element: <History />, icon: <AccessTimeIcon sx={{ fontSize: 20 }} /> },
      // { path: "/OysterM8/DataDownload", label: "Data Download", element: <DataDownload />, icon: <GetAppIcon sx={{ fontSize: 20 }} /> },
    ],
  },
  {
    title: "Records",
    items: [
      { path: "/OysterM8/Logs/Deployments", label: "Deployments", element: <Deployments />, icon: <LocalShippingIcon sx={{ fontSize: 20 }} /> },
      { path: "/OysterM8/Logs/Movements", label: "Movements", element: <Movements />, icon: <SyncAltIcon sx={{ fontSize: 20 }} /> },
      { path: "/OysterM8/Logs/LeaseStats", label: "Lease Information", element: <LeaseBreakDown />, icon: <HomeWorkOutlinedIcon sx={{ fontSize: 20 }} /> },
      { path: "/OysterM8/Logs/FlipHistory", label: "Flip History", element: <FlipHistory />, icon: <AccessTimeIcon sx={{ fontSize: 20 }} /> },
      { path: "/Farmers/EquipmentRegistry", label: "Equipment Registry", element: <EquipmentRegistryPage />, icon: <InventoryOutlinedIcon sx={{ fontSize: 20 }} /> },
      { path: "/OysterM8/TotalsReport", label: "Totals Table", element: <TotalsReport />, icon: <AssessmentIcon sx={{ fontSize: 20 }} /> },
      { path: "/Farmers/AOCProcurement", label: "AOC Procurement", element: <FarmReports />, icon: <AssessmentIcon sx={{ fontSize: 20 }} /> },
      { path: "/Farmers/OysterMateTotals", label: "Oyster Mate Totals", element: <TransfersandFarmTotals />, icon: <AssessmentIcon sx={{ fontSize: 20 }} /> },
      {
        path: "/Farmers/OTR",
        label: "Sales",
        element: <FarmOTRs />,
        icon: <SyncAltIcon sx={{ fontSize: 20 }} />,
        children: [
          { path: "/Farmers/OTR?status=Received", label: "Open" },
          { path: "/Farmers/OTR?status=Cancelled", label: "Cancelled" },
        ],
      },
    ],
  },
  {
    title: "Admin",
    items: [
      { path: "/Admin/Customers", label: "Customers", element: <OCloudCustomers />, icon: <RequestQuoteIcon sx={{ fontSize: 20 }} /> },
      { path: "/Admin/Suppliers", label: "Suppliers", element: <OCloudSuppliers />, icon: <StorefrontIcon sx={{ fontSize: 20 }} /> },
      { path: "/Admin/CropColours", label: "Crop Colours", element: <OCloudCropColours />, icon: <PaletteIcon sx={{ fontSize: 20 }} /> },
      { path: "/Admin/Grades", label: "Grades", element: <OCloudGrades />, icon: <LabelIcon sx={{ fontSize: 20 }} /> },
      { path: "/Admin/UnitTypes", label: "Unit Types", element: <OCloudUnitTypes />, icon: <CategoryIcon sx={{ fontSize: 20 }} /> },
    ]
  },
];

export const flatRoutes = routeSections.flatMap((section) => section.items);
export const appRoutes = [...flatRoutes, { ...mapRoute, path: "/OysterM8" }];
